module.exports = __webpack_public_path__ + "static/img/btn4.ea3082a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/btn4.png
// module id = SDQJ
// module chunks = 1